<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      {{ actionDate.name }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ actionDate.description }}
    </div>

    <div :style="`width: ${columns[2].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditActionDateDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteActionDate"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.permits.action_dates.delete_action_date_dialog.confirm_text') }}
              {{ actionDate.name }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditPermitActionDateDialog
      :is-open="isEditActionDateDialogOpen"
      :document-id="actionDate.id"
      @close="isEditActionDateDialogOpen = false"
    />
  </div>
</template>

<script>

import { getValidationError } from '@/helpers';
import EditPermitActionDateDialog
  from '@/components/Administration/PermitManagement/ActionDates/EditPermitActionDateDialog.vue';

export default {
  name: 'PermitActionDateListItem',
  components: { EditPermitActionDateDialog },
  props: {
    actionDate: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditActionDateDialogOpen: false,
      isDeleting: false,
    };
  },

  methods: {
    async deleteActionDate() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/permitManagement/actionDates/deleteActionDate', this.actionDate.id);
      } catch (e) {
        this.$message.error({
          message: this.$capitalize(e.response.data.message),
          showClose: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
